import axios from 'axios';
import axiosInstance from './axiosInstance';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = '/support-tickets';
const ADMIN_BASE = '/admin/support-tickets';

// Create admin axios instance with admin token
const adminAxios = axios.create({ baseURL: BASE_URL });
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// USER ENDPOINTS (use user axios instance)
export const createSupportTicket = (data) => axiosInstance.post(BASE, data);
export const getMyTickets = (params) => axiosInstance.get(BASE, { params });
export const getSupportTicket = (id) => axiosInstance.get(`${BASE}/${id}`);
export const replyToTicket = (id, data) => axiosInstance.post(`${BASE}/${id}/reply`, data);
export const closeTicket = (id, data) => axiosInstance.patch(`${BASE}/${id}/close`, data);

// ADMIN ENDPOINTS (use admin axios instance)
export const getAdminSupportTickets = (params) => adminAxios.get(ADMIN_BASE, { params });
export const getAdminSupportTicket = (id) => adminAxios.get(`${ADMIN_BASE}/${id}`);
export const assignTicket = (id, data) => adminAxios.patch(`${ADMIN_BASE}/${id}/assign`, data);
export const updateTicketStatus = (id, data) => adminAxios.patch(`${ADMIN_BASE}/${id}/status`, data);
export const replyToTicketAdmin = (id, data) => adminAxios.post(`${ADMIN_BASE}/${id}/reply`, data);
